import React from 'react'
import { Button } from 'reactstrap'
import { LOCALSTORAGE_STATE_KEY } from 'web/utils/local-storage'

/**
 * AI gunk
 */
export const TakeBackupButton: React.FC = () => {
    const handleDownload = () => {
        const key = 'yourLocalStorageKey'
        const value = localStorage.getItem(LOCALSTORAGE_STATE_KEY)

        if (value != null) {
            const blob = new Blob([value], { type: 'text/plain' })
            const url = URL.createObjectURL(blob)

            const linkElement = document.createElement('a')
            linkElement.href = url
            linkElement.download = `raicd_backup_${new Date().toISOString()}.json`

            document.body.appendChild(linkElement)
            linkElement.click()

            URL.revokeObjectURL(url)
            document.body.removeChild(linkElement)
        } else {
            console.error(`No value found in localStorage for key: ${key}`)
        }
    }

    return (
        <div>
            <Button
                onClick={handleDownload}
                size='sm'
                outline
            >
                {'Backup'}
            </Button>
        </div>
    )
}

